@if (this.isSessionActive) {
  <button
    style="padding: 5px 5px 0px 5px; margin: 0px"
    (click)="this.btnOpenDetails_click()"
  >
    <mat-icon>personal_video</mat-icon> Client
  </button>
}

<img
  #pointer
  id="pointer"
  src="/assets/images/pointer.gif"
  style="width: auto; height: auto; position: absolute; visibility: hidden"
/>
